// extracted by mini-css-extract-plugin
export default {"wrapper":"J2Rb2pbbqUGTOW-xuD2vOA=="};